import type { FaireProductEntity } from "../../entity_types/product";

export const p_d61mh07b: FaireProductEntity = {
  token: "p_d61mh07b",
  type: "product",
  name: "Salt n Pepa Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/1fba5c69b30409da43d0b994a38e3106170b8eeafdc852cea6e9e74ba459ace2/1528361142.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/c12236c85966f2def4f0a1b55db53c6ce5c928e2627c95391a9f0b3eefc9a05d/1528361142.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:16.250Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
